import { render } from "./SatisfactionGuarantee.vue?vue&type=template&id=18091028&scoped=true"
import script from "./SatisfactionGuarantee.vue?vue&type=script&lang=js"
export * from "./SatisfactionGuarantee.vue?vue&type=script&lang=js"

import "./SatisfactionGuarantee.vue?vue&type=style&index=0&id=18091028&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18091028"]])

export default __exports__